module.exports = __webpack_public_path__ + "static/img/timetable_widget_3.15f243c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/timetable_widget_3.png
// module id = 5YAM
// module chunks = 11